import React, { useState, useEffect } from 'react';

import {
  getAllCategoriesWithPostCounts,
  createCategory,
  updateCategory,
  deleteCategory,
} from '../../../api/services/blogPostCategoriesApi';

import useEntityModals from '../../../hooks/admin/useEntityModals/useEntityModals';

import ContentChangeButton from '../../../components/admin/buttons/ContentChangeButton/ContentChangeButton';
import AdminCategoryCard from '../../../components/admin/cards/AdminCategoryCard/AdminCategoryCard';
import BlogPostCategoryModal from '../../../components/admin/modals/BlogPostCategoryModal/BlogPostCategoryModal';
import ConfirmDeleteModal from '../../../components/admin/modals/ConfirmDeleteModal/ConfirmDeleteModal';

import './AdminBlogCategories.css';

const AdminBlogCategories = () => {
  const {
    selected,
    isEditModalOpen,
    isDeleteModalOpen,
    editModalMode,
    editModalError,
    setEditModalError,
    openAddModal,
    openEditModal,
    closeEditModal,
    openDeleteOrInfoModal,
    closeDeleteModal,
  } = useEntityModals();

  const [categories, setCategories] = useState([]);

  const fetchCategories = async () => {
    const categoriesWithPostCount = await getAllCategoriesWithPostCounts();
    setCategories(categoriesWithPostCount);
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  /* ---------- Submit ---------- */

  const handleCategorySubmit = async (formData) => {
    try {
      setEditModalError('');

      if (editModalMode === 'edit') {
        await updateCategory(selected._id, formData);
        alert('Category updated successfully!');
      } else {
        await createCategory(formData);
        alert('Category created successfully!');
      }

      await fetchCategories();
      closeEditModal();
    } catch (error) {
      console.error('Submit failed:', error);

      setEditModalError(
        error.message || 'Something went wrong.  Please try again.',
      );
    }
  };

  /* ---------- Delete ---------- */

  const onCategoryConfirmDelete = async () => {
    try {
      await deleteCategory(selected._id);

      await fetchCategories();
      closeDeleteModal();

      alert(`Deleted! ${selected.name} deleted successfully!`);
    } catch (err) {
      console.error(err);
      alert('Failed to delete category');
    }
  };

  return (
    <>
      <div className='admin-blog-metadata-categories-container'>
        <div className='admin-blog-metadata-title-add-category-container'>
          <h1 className='admin-blog-metadata-categories-title'>Categories</h1>

          <ContentChangeButton
            iconType='add'
            size='large'
            width='long'
            onClickHandler={openAddModal}
          >
            Add Category
          </ContentChangeButton>
        </div>

        <div className='admin-blog-metadata-category-cards-container'>
          {categories.map((c) => (
            <AdminCategoryCard
              key={c._id}
              categoryWithPostCount={c}
              onEditClickHandler={openEditModal}
              onDeleteClickHandler={openDeleteOrInfoModal}
            />
          ))}
        </div>
      </div>

      {/* Modals */}
      {isEditModalOpen && (
        <BlogPostCategoryModal
          onClose={closeEditModal}
          onSubmit={handleCategorySubmit}
          blogPostCategory={selected}
          mode={editModalMode}
          errorMsg={editModalError}
        />
      )}

      {isDeleteModalOpen && (
        <ConfirmDeleteModal
          onClose={closeDeleteModal}
          onConfirm={onCategoryConfirmDelete}
          deleteItemTitle={`${selected?.name}`}
        />
      )}
    </>
  );
};

export default AdminBlogCategories;
